// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* Uniform size so "Manager" and "On-Call Provider" chips match; text
     centers and wraps within this width rather than each chip sizing to
     its own content. */
  min-width: 140px;
  min-height: 30px;
  padding: 0.3em 0.9em;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  border-radius: 50px;
  /* Muted "tag" treatment: soft tint + darker same-hue text + hairline
     border, so chips read as passive status labels, not interactive buttons. */
  border: 1px solid transparent;
}

.bg-primary {
  background-color: #eaecf3;
  border-color: #d6dae8;
  color: #1f2a5c;
}

.bg-secondary {
  background-color: #e2f1fb;
  border-color: #bfe1f5;
  color: #0b6d9c;
}










`, "",{"version":3,"sources":["webpack://./src/components/Badge/Badge.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB;;uBAEqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB;+EAC6E;EAC7E,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  /* Uniform size so \"Manager\" and \"On-Call Provider\" chips match; text\n     centers and wraps within this width rather than each chip sizing to\n     its own content. */\n  min-width: 140px;\n  min-height: 30px;\n  padding: 0.3em 0.9em;\n  font-size: 0.85rem;\n  font-weight: 600;\n  line-height: 1.25;\n  text-align: center;\n  border-radius: 50px;\n  /* Muted \"tag\" treatment: soft tint + darker same-hue text + hairline\n     border, so chips read as passive status labels, not interactive buttons. */\n  border: 1px solid transparent;\n}\n\n.bg-primary {\n  background-color: #eaecf3;\n  border-color: #d6dae8;\n  color: #1f2a5c;\n}\n\n.bg-secondary {\n  background-color: #e2f1fb;\n  border-color: #bfe1f5;\n  color: #0b6d9c;\n}\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
